import { render, staticRenderFns } from "./leftSidebarError.vue?vue&type=template&id=0bc490ea&lang=pug&"
import script from "./leftSidebarError.vue?vue&type=script&lang=ts&"
export * from "./leftSidebarError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports